export default __webpack_public_path__ + "static/media/collections-option-3.cf345000.jpg";